// extracted by mini-css-extract-plugin
export default {"listItem":"ListItem--listItem--0c7f0d","icon":"ListItem--icon--69aa78","title":"ListItem--title--702fda","description":"ListItem--description--887359"};